import React from "react";
import Button from "../../../../components/Button";
import {useIndividualizationContext} from "../../../../contexts/individualizationContext";
import {useTranslation} from "react-i18next";
import styles from './NavButtons.module.css'
import cx from "classnames";

const NavButtons: React.FC<{method: 'store'|'update'|'duplicate'}> = ({method}) => {
    const {
        activeStep,
        changeActiveStep,
        steps,
        completedSteps,
        submitIndividualization,
        submitUpdateIndividualization,
        submitDuplicateIndividualization
    } = useIndividualizationContext()
    const {t} = useTranslation(['individualization'])

    const handleBackButtonClick = (e: React.MouseEvent<HTMLButtonElement, MouseEvent>) => {
        if (activeStep > 0) changeActiveStep(activeStep - 1);
        (e.target as HTMLButtonElement).blur()
    }

    const handleNextButtonClick = (e: React.MouseEvent<HTMLButtonElement, MouseEvent>) => {
        if (activeStep < steps.length - 1) changeActiveStep(activeStep + 1);
        (e.target as HTMLButtonElement).blur()
    }

    const handleSubmitButtonClick = (e: React.MouseEvent<HTMLButtonElement, MouseEvent>) => {
        switch (method) {
            case "store":
                submitIndividualization()
                break;
            case "duplicate":
                submitDuplicateIndividualization()
                break;
            case "update":
                submitUpdateIndividualization()
                break;
            default:
                break;
        }
        (e.target as HTMLButtonElement).blur()
    }

    return (
        <div className={cx(styles['nav-buttons-wrapper'])}>
            <Button
                text={t('nav.back')}
                disabled={activeStep < 1}
                fn={handleBackButtonClick}
                hierarchy={"primary"}
                classes={'my-2'}
            />
            {activeStep < steps.length - 1 ?
                <Button
                    text={t('nav.next')}
                    fn={handleNextButtonClick}
                    hierarchy={"primary"}
                    classes={'my-2'}
                    disabled={activeStep >= steps.length - 1}
                /> :
                <Button
                    text={t('nav.submit')}
                    classes={'my-2'}
                    fn={handleSubmitButtonClick}
                    hierarchy={"primary"}
                    disabled={completedSteps.length !== steps.length}
                />
            }
        </div>
    );
}

export default NavButtons;
